import Enumerable from "linq";
import { ClaioImageReference } from "./ClaioImageReference";
import { Directory } from "../../../../../domain/drawing";

export class ClaioImageRootReference {
  constructor(
    public folders: Directory<number, ClaioImageReference>[]) {
  }

  clone() {
    return new ClaioImageRootReference(
      Enumerable.from(this.folders)
        .select(d => d.clone())
        .toArray()
    );
  }
}
